@if (show) {
  <div class="overlay">
    <pu-icon
      iconName="close"
      size="16"
      class="close"
      (click)="close()"
    />

    @if (!!pdf()) {
      <pu-flip-book
        [source]="pdf()"
        [options]="flipBookOptions"
      />
    } @else if (media().length > 0) {
      <div class="arrow left">
        <pu-icon
          iconName="pu-chevron-left"
          size="32"
          (click)="prev(); $event.stopPropagation()"
        />
      </div>

      <div
        class="slider-wrapper"
        (click)="$event.stopPropagation()"
      >
        <div
          class="slider-track"
          [style.transform]="getTransform()"
        >
          @for (url of media(); track url) {
            <div class="slide">
              @if (isYouTube(url)) {
                <iframe
                  [src]="sanitize(url)"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              } @else {
                <img
                  ptImageLoader
                  [src]="url"
                  alt="Slide media"
                />
              }
            </div>
          }
        </div>
      </div>

      <div class="arrow right">
        <pu-icon
          iconName="pu-chevron-right"
          size="32"
          (click)="next(); $event.stopPropagation()"
        />
      </div>

      <div class="counter">
        <span class="currentIndex">{{ index + 1 }}</span> / {{ media().length }}
      </div>
    }
  </div>
}
